<template>
    <div>
        <v-card>
            <v-expansion-panels flat v-model="panel">
                <v-expansion-panel
                    class="mb-2"
                    flat
                    v-for="(d, i) in datas"
                    :key="i"
                >
                    <v-expansion-panel-header icon-rotate class="text-center rounded-lg font-weight-bold" :class="[panel===0 ? 'expansion-header' : 'expansion-close']" >
                        <span class="body-2">{{ i }} - Count: {{ d.count }}</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-5">
                        <v-data-table
                            :headers="headers"
                            :items="d.rows"
                            :items-per-page="10"
                            hide-default-footer
                        >
                            <template v-slot:item.status="{item}">
                                <v-btn v-if="item.isDied" rounded dense small class="" outlined color="red">Dead</v-btn>
                                <v-btn v-else rounded dense small class="" outlined color="primary">Active</v-btn>
                            </template>
                            <template v-slot:item.actions="{item}">
                                <v-btn text dense small depressed color="primary" class="text-capitalize" @click="$router.push({name: 'AnimalDetails', params: {animal_number: item.animalNumber}})">View</v-btn>    
                            </template>
                        </v-data-table>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
            <div v-if="typeof datas === 'object' && Object.keys(datas).length < 1" class="text-center py-10">No Data Available</div>
        </v-card>
    </div>
</template>

<script>
import EPDService from "@/_services/EPDService";
import loadingMixin from "@/mixins/LoadingMixin";

export default {
    mounted() {
        this.startLoading()
        EPDService.getSingleEpdInfo(this.$route.params.geneticid, 'progency')
        .then(({data}) => {
            this.datas = data.list
            // data.progencyList.forEach    (a => {
            //     if(Array.isArray(this.datas[a.birthYear])){
            //         this.datas[a.birthYear].push(a)
            //     }else{
            //         this.datas[a.birthYear] = []
            //         this.datas[a.birthYear].push(a)
            //     }
            // })
            // console.log('aaa', this.datas)
        })
        .catch(e => {
            console.log('err', e)
        })
        .finally(() => {
            this.stopLoading()
        })
    },
    data() {
        return {
            datas: {},
            panel: 0,
            desserts: [
                {
                    Name: 'Frozen Yogurt',
                    Gender: 'Male',
                },
                {
                    Name: 'Ice cream sandwich',
                    Gender: 'Male',
                },
            ],
            headers: [
                {
                    text: this.$t('Gender'),
                    value: "gender",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$t('Animal ID'),
                    value: "animalNumber",
                    sortable: false,
                    align: 'start',
                    class: "black--text ",
                    width: "10%"
                },
                {
                    text: this.$t('Registration'),
                    value: "registrationNumber",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$t('Name'),
                    value: "name",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$t('Date of Birth'),
                    value: "birthDate",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$t('Age'),
                    value: "age",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$t('Status'),
                    value: "status",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
                {
                    text: '',
                    value: "actions",
                    class: "black--text px-0",
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    mixins: [loadingMixin]
}
</script>

<style scoped>
.expansion-header {
    border: 1px solid #FFB443 !important; 
    background-color: #FFF7EC !important;
 }

 .expansion-close {
    background-color: #9695943a !important;
    border-radius: 0px !important;
 }

 .label {
     margin-bottom: 20px !important;
 }
</style>